module.exports = __webpack_public_path__ + "img/forCallLogs.1b9d3cff.png";